import React from 'react';
import PropTypes from 'prop-types';
import {VoltageDisplay} from '../VoltageDisplay';
import {ButtonControls} from '../ButtonControls';
import {useTranslation} from 'react-i18next';

import './style.scss';

const VOLTAGE_INCREMENT = 10;
const CURRENT_INCREMENT = 0.1;

const TRANSLATION_KEY = {
  SET_VOLTAGE: 'SetVoltage.string',
  VOLTAGE: 'Voltage.string',
  CURRENT: 'Current.string',
  IncreaseVoltageButton: 'IncreaseVoltageButton.string',
  DecreaseVoltageButton: 'DecreaseVoltageButton.string',
  IncreaseCurrentButton: 'IncreaseCurrentButton.string',
  DecreaseCurrentButton: 'DecreaseCurrentButton.string'
};

export function VoltageBlock(props) {
  const {t} = useTranslation();

  const incrementVoltage = () =>
    props.setVoltage(props.voltage + VOLTAGE_INCREMENT);
  const decrementVoltage = () =>
    props.setVoltage(props.voltage - VOLTAGE_INCREMENT);

  const incremnetCurrent = () => {
    const newValue = props.current + CURRENT_INCREMENT;
    props.setCurrent(roundOffValue(newValue));
  };
  const decrementCurrent = () => {
    const newValue = props.current - CURRENT_INCREMENT;
    props.setCurrent(roundOffValue(newValue));
  };
  return (
    <div className={`ps_settings_voltage ${props.className} `}>
      <h5 className='ps_settings_voltage_title'>
        {t(TRANSLATION_KEY.SET_VOLTAGE)}
      </h5>
      <VoltageDisplay
        voltage={props.voltage}
        current={props.current}
        setVoltage={props.setVoltage}
        setCurrent={props.setCurrent}
      />
      <div className='ps_settings_voltage_controlBlock'>
        <ButtonControls
          text={t(TRANSLATION_KEY.VOLTAGE)}
          increment={incrementVoltage}
          decrement={decrementVoltage}
          altText1={t(TRANSLATION_KEY.IncreaseVoltageButton, {voltage: props.voltage})}
          altText2={t(TRANSLATION_KEY.DecreaseVoltageButton, {voltage: props.voltage})}
        />
        <ButtonControls
          text={t(TRANSLATION_KEY.CURRENT)}
          increment={incremnetCurrent}
          decrement={decrementCurrent}
          altText1={t(TRANSLATION_KEY.IncreaseCurrentButton, {current: props.current})}
          altText2={t(TRANSLATION_KEY.DecreaseCurrentButton, {current: props.current})}
        />
      </div>
    </div>
  );
}

VoltageBlock.propTypes = {
  ...VoltageDisplay.propTypes,
};

VoltageBlock.defaultProps = {};

const roundOffValue = (number) => {
  return Math.round((number + Number.EPSILON) * 10) / 10;
};
